// Import Packages
import React, { useEffect, useState, useRef } from 'react'
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import HTMLReactParser from "html-react-parser";
import { useTranslation } from 'react-i18next';

// Import Material UI
import { Tooltip, Button } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import Close from "@material-ui/icons/Close";
import CircularProgress from '@material-ui/core/CircularProgress';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";

// Import Pages
import { TextInput } from '../../FlowConfigurationInputs/TextInput/NewTextInput';
import BoolSelect from '../../FlowConfigurationInputs/BoolSelect/BoolSelect'
import VariablePicker from '../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import CustomTab from '../../FlowConfigurationInputs/CustomTab/CustomTab';
import CustomDateTab from '../../FlowConfigurationInputs/CustomDateTab/CustomDateTab';
import FieldLabel from '../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import OauthQuestion from "../../DataTable/DeleteConfirm";

import CustomButton from "../../Button/Button";
import AppCredentialModal from "../../../home/pages/appCredential/appCredentialModal/AppCredentialModal";
import ConnectorField from "../../../home/pages/automs/newFlow/middleArea/connectorField/ConnectorField";
import {
    triggerConf,
    alertState,
    initialActions,
    saveAvailable,
    changedFields,
    inputRefresh
} from "../../../recoil-store/recoil-state";

// Import Services
import VariableService from '../../../services/VariableService/VariableService';
import ActionService from '../../../services/ActionService/ActionService'
import ApplicationService from '../../../services/ApplicationService/ApplicationService';

// Import Icons
import deleteIcon from '../../../assets/icons/delete-icon.svg';
import AddIcon from "@material-ui/icons/Add";

// Import CSS
import './CustomAction.css';
import { CheckIfFlowUpdated } from "../../../helpers/helper";

const CustomAction = ({
    action,
    variables,
    setOpenVariable,
    variableRender,
    debuggingStart,
    debuggingExpand,
    automVersionId,
    automId,
    setVariables,
    automDetail,
    setAutomDetail,
    fromFlow,
    getVariables
}) => {
    const setInputRefreshGlobal = useSetRecoilState(inputRefresh);

    const [applicationCredentials, setApplicationCredentials] = useState([]);
    const [appConnectors, setAppConnectors] = useState([]);
    const [selectedConnectors, setSelectedConnectors] = useState({});
    const [changedConnector, setChangedConnector] = useState(false);

    //const [selectedCustomSelectableField, setSelectedCustomSelectableField] = useState({});
    const [customInputs, setCustomInputs] = useState([]);
    const [itemId, setItemId] = useState();
    const [customOutputs, setCustomOutputs] = useState([]);
    const [applications, setApplications] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [openAppCredential, setOpenAppCredential] = useState(false);
    const [loading, setLoading] = useState(true);
    const [fieldOptions, setfieldOptions] = useState({});
    //const [selectedInputOption, setSelectedInputOption] = useState({});
    // application field congiguration application id
    const [aafcApplicationId, setAafcApplicationId] = useState('');
    const [sysActionFields, setSysActionFields] = useState({});
    const [credentialQuestion, setCredentialQuestion] = useState(false);

    // const [sampleResponses, setSampleResponses] = useState({});
    const [triggerConfig, setTriggerConfig] = useRecoilState(triggerConf);
    // const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    const [fieldLoading, setFieldLoading] = useState(false);


    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const setChangeFields = useSetRecoilState(changedFields);
    const changedFieldsState = useRecoilValue(changedFields);

    const setAlert = useSetRecoilState(alertState);
    const sysActionFieldName = 'sys_action_fields';

    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.CUSTOM-ACTION."


    useEffect(() => {
        if (action.actionId) {
            setChangedConnector(false);
            // if (!loading) {
            setLoading(true);
            //  }
            const fetchData = async () => {
                setAppConnectors([])
                const res = await ActionService.getActionByFilter(action.actionId);
                if (!res.status && res.message === 'VERSION-NOT-FOUND') {
                    return setAlert(alert => ({
                        ...alert,
                        show: true,
                        message: t(label + res.message, { action: action.actionName, library: action.libraryName }),
                        severity: 'error'
                    }));
                }
                //const actionFieldConf = await ActionService.getActionFieldConfiguration(action.actionId);

                // const res = await VariableService.getVariableFilter(action.autom_id, 1, 1);
                let data = res.data.variables.filter(x => !x.system_variable && (x.is_input || x.is_output));
                // find system application field variables by finding sys_ and _fields in the string
                let sysVariables = data.filter(x => x.name.substring(0, 4) === "sys_" && x.name.substring(x.name.length - 7) === "_fields");

                // find variable with type app connector
                const ac = data.filter(d => d.type === "app connector");

                // find application_id
                let app_id;
                if (res.data.action.application_action_field_configurations && res.data.action.application_action_field_configurations.length) {
                    app_id = res.data.action.application_action_field_configurations[0].application_id;
                }

                let sc = {};
                // set selected credential
                if (ac && ac.length) {
                    let appIds = [];
                    ac.map((c) => {
                        appIds.push(c.default_value);
                    })

                    // getting app credentials by using application ids
                    const appCredentials = await getApplicationCredentials(appIds);
                    if (appCredentials.length) {
                        setApplicationCredentials(appCredentials);
                    }

                    // set selectedConnectors
                    ac.map((c) => {
                        if (action.fields[c.name]?.value && appCredentials.find(x => x.id === action.fields[c.name]?.value)) {
                            sc[c.name] = { value: action.fields[c.name]?.value }
                        } else {
                            sc[c.name] = '';
                            action.fields[c.name] = { value: '', type: "app_connector", is_required: c.is_required }
                        }
                    })

                    setAppConnectors(ac)
                    setSelectedConnectors(sc);
                    if (Object.keys(sc).length < 1 || (sc.hasOwnProperty("app_connector") && Object.keys(sc.app_connector).length < 1)) {

                        // set selectedConnectors
                        ac.map((c) => {
                            const defaultValue = appCredentials.find(x => x.is_default === true);
                            if (defaultValue && Object.keys(defaultValue).length > 0) {
                                sc[c.name] = { value: defaultValue.id }
                                action.fields[c.name].value = defaultValue.id;
                            } else {
                                sc[c.name] = '';
                                action.fields[c.name] = { value: '', type: "app_connector", is_required: c.is_required }
                            }
                        })
                        setSelectedConnectors(sc);

                    }
                    // getting application by ids
                    const app = await getApplications({ id: appIds });
                    if (app && app.length) {
                        setApplications(app);
                    }
                }

                // filtering input & autput variables to let user see those fields on the form
                data = data.filter(function (obj) {
                    // looking for system app fields variables is exist in variables
                    const sysSearch = sysVariables.find(x => x.name === obj.name)

                    // check if exists then make it hidden from configuration form
                    if (sysSearch) {
                        return obj.type !== "app connector" && obj.name !== sysSearch.name;
                    }

                    // return variables which has no type as app connector
                    return obj.type !== "app connector";
                });

                let inputs = [];
                let outputs = [];
                let created = false;
                for (let item of data) {
                    if (!item.system_variable) {
                        if (item.is_input) {
                            if (!action.fields[item.name]) {
                                action.fields[item.name] = { value: item.default_value ? item.default_value : '', isRequired: item.is_required }
                            }
                            inputs.push(item);
                        } else {
                            if (!action.fields[item.name]) {
                                await createOutputVariable(item);
                                created = true;
                            } else {
                                if (variables.findIndex(x => x.related_item_id === action.item_id) === -1) {
                                    await createOutputVariable(item);
                                    created = true;
                                }
                            }
                            outputs.push(item);
                        }
                    }
                }

                if (outputs.length && getVariables && created) {
                    getVariables(automVersionId);
                }
                inputs.sort((a, b) => (a.order > b.order) ? 1 : -1)
                outputs.sort((a, b) => (a.order > b.order) ? 1 : -1)

                if (action.fields[sysActionFieldName]) {
                    // let sysaf = {};
                    // Object.keys(action.fields[sysActionFieldName].value).map((c) => {
                    //     if (action.fields[sysActionFieldName].value[c]?.value) {
                    //         sysaf[c] = action.fields[sysActionFieldName].value[c]?.value;
                    //     } else {
                    //         sysaf[c] = '';
                    //     }
                    // })
                    // setSelectedCustomSelectableField(sysaf);
                    setSysActionFields(action.fields[sysActionFieldName].value);
                } else {
                    action.fields[sysActionFieldName] = { type: 'object', value: {} };
                    setSysActionFields({});
                }
                setCustomInputs(inputs);
                setCustomOutputs(outputs);

                setItemId(action.item_id);

                if (app_id) {
                    // if (res.data.action.application_action_field_configurations && res.data.action.application_action_field_configurations.length) {
                    //   const app_id = res.data.action.application_action_field_configurations[0].application_id;

                    const conn = ac.find(c => c.default_value === app_id);
                    if (conn && sc[conn.name]) {
                        const app_connector_id = sc[conn.name].value;
                        const hasError = await fetchInputOptions(app_connector_id);
                        if (hasError) {
                            handleExpireToken(conn.name, sc)
                        }
                    }
                    setAafcApplicationId(app_id);
                }

                setLoading(false);
            }
            fetchData().then(r => r);
        }
    }, [refresh, action.item_id])

    useEffect(() => {
        if (action.actionId && applicationCredentials.length && (action.fields?.app_connector && !action.fields.app_connector.name)) {
            applicationCredentials.forEach((credential) => {
                if (credential.is_default) {
                    setLoading(true);
                    handleChangeCredential(credential, "app_connector", true).then((r) => r)
                }
            })
        }
    }, [applicationCredentials])

    const createOutputVariable = async (item) => {
        let variable = {
            name: '',
            type_id: item.type_id,
            autom_version_id: automVersionId,
            display_name: '',
            related_item_id: action.item_id,
            default_value: null,
            is_input: false,
            is_output: false,
            is_custimuzable: false,
        }
        // let vv = variables.filter(x => x.name.includes('output_'));
        // if (vv) {
        //     let number = 0;
        //     // Searching for the most recently created output
        //     for (const v of vv) {
        //         const n = parseInt(v.name.split('_')[1]);
        //         if (n > number) {
        //             number = n;
        //         }
        //     }
        //     // set variable name
        //     variable.name = 'output_' + (number + 1);
        // } else {
        //     variable.name = 'output_1';
        // }
        variable.name = `${action.actionName.replaceAll(' ', '')}_${item.name}_${action.item_id.replaceAll('-', '')}`
        const result = await VariableService.postVariable(variable);
        if (result && result.status) {
            action.fields[item.name] = { value: variable.name, isRequired: item.is_required }
            // update variables
            // variable.id = result.id;
            // variable.type = item.type;
            // let copyVariable = [...variables];
            // copyVariable.push(variable);
            // setVariables(copyVariable);

            let copyItems = JSON.parse(JSON.stringify(automDetail.items))

            findAndUpdateItem(copyItems)
            setAutomDetail({
                ...automDetail,
                items: copyItems
            })

        } else {
            action.fields[item.name] = { value: '', isRequired: item.is_required }
        }
    }

    const findAndUpdateItem = (items) => {
        items.forEach(item => {
            if (item.item_id === action.item_id) {
                item.fields = JSON.parse(JSON.stringify(action.fields))
                return;
            } else if (item.children) {
                findAndUpdateItem(item.children)
            }
        })
    }

    const cancel = () => {
        setOpenAppCredential(false)
    }

    const afterSave = (t) => {
        setRefresh(t);
        setOpenAppCredential(false);
    }

    const getApplicationCredentials = async (ids) => {
        if (ids) {
            const response = await ApplicationService.getAppCredentials({ application_id: ids });
            if (response && response.status && response.data.length) {
                return response.data;
            }
        }
        return [];
    }

    const getApplications = async (filter = {}) => {
        const response = await ApplicationService.getApplications(filter);
        if (response && response.status && response.data.length) {
            return response.data;
        }

        return [];
    }

    const handleChangeCredential = async (credential, name, isShowDefault) => {
        if (credential.id) {
            if (!isShowDefault) setLoading(true);
            setChangedConnector(true);
            const field = initialActionsData[action.id]?.fields[name];
            let oldValue = !field ? undefined : field.value;
            CheckIfFlowUpdated(name, action, oldValue, credential.id, setSaveAvailable, setChangeFields, changedFieldsState);
            let copyConnectors = { ...selectedConnectors };
            copyConnectors[name] = { value: credential.id };
            setSelectedConnectors(copyConnectors);
            action.fields[name].value = credential.id;
            action.fields[name].name = credential.name;
            action.inputs = undefined;

            const hasError = await fetchInputOptions(credential.id);
            if (hasError) {
                handleExpireToken(name, copyConnectors)
            }
            if (!isShowDefault) setLoading(false);
        }
    }

    const fetchInputOptions = async (app_connector_id) => {
        const resp = await ActionService.getInputValueOptions(action.actionId, app_connector_id, action.inputs);
        if (resp.code === 200) {
            //let _selectedInputOption = { ...selectedInputOption };
            // for (const key of Object.keys(resp.data)) {
            //     if (action.fields[key] && action.fields[key].value) {
            //         // if (action.fields[key].tab && action.fields[key].tab === 0 && !resp.data[key]?.options?.find(x => x.value === action.fields[key].value)) {
            //         //     //_selectedInputOption[key] = action.fields[key].value;
            //         //     action.fields[key].value = ""
            //         // }
            //         //else {
            //         //  action.fields[key].value = ""
            //         // _selectedInputOption[key] = ""
            //         //}
            //     }
            // }
            //setSelectedInputOption(_selectedInputOption);
            setfieldOptions(resp.data);
        } else if (resp.code === 401) {
            setfieldOptions({});
            return true;
        } else {
            setfieldOptions({});
        }
    }
    const openCredentialModal = () => {
        setOpenAppCredential(true);
    }

    const MyToolTip = ({ description }) => {
        // marginRight: 32, marginLeft: 5, position: "relative", top: 7 
        return (
            description && (
                <Tooltip title={HTMLReactParser(description)}>
                    <InfoIcon style={{ width: 15, height: 15, marginLeft: 5 }} />
                </Tooltip>
            )
        )
    }

    // set action field
    const setSysField = async (inputName, value) => {
        let copyFields = { ...sysActionFields };
        if (!copyFields[inputName] && value.options && value.options.length === 0) {
            const conn = appConnectors.find(c => c.default_value === aafcApplicationId);
            if (conn && selectedConnectors[conn.name]) {
                const app_connector_id = selectedConnectors[conn.name].value;
                const resp = await ActionService.getSysFieldOptions(action.actionId, app_connector_id, [inputName], action.inputs);
                if (resp.code === 200 && resp.data[inputName]) {
                    value.options = resp.data[inputName].options;
                    value.type = 'select';
                    if (resp.data[inputName].option_fetch_error) {
                        value.option_fetch_error = true;
                    }
                }
            }
        }

        if (value.type === "number") {
            if (value.value.trim() !== '' && !isNaN(value.value)) {
                value.value = parseInt(value.value, 10)
            } else {
                //value.value = "";
            }
        }

        if (value.type === "decimal") {
            if (value.value.trim() !== '' && !isNaN(value.value)) {
                value.value = parseFloat(value.value)
            } else {
                value.value = "";
            }
        }

        action.fields[sysActionFieldName].value[inputName] = value;

        const field = initialActionsData[action.id]?.fields[sysActionFieldName];
        let oldValue = !field ? undefined : field.value[inputName]?.value;
        let newValue = value.value !== undefined ? value.value : value;
        CheckIfFlowUpdated(inputName, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
        setTimeout(() => {
            copyFields[inputName] = value;
            setSysActionFields(copyFields);
            // setSaveAvailable(true);
        }, 300)
    }

    const setSysFieldAdd = async (inputName, value) => {
        setFieldLoading(inputName)
        let copyFields = { ...sysActionFields };
        if (!copyFields[inputName] && value.options && value.options.length === 0) {
            const conn = appConnectors.find(c => c.default_value === aafcApplicationId);
            if (conn && selectedConnectors[conn.name]) {
                const app_connector_id = selectedConnectors[conn.name].value;
                const resp = await ActionService.getSysFieldOptions(action.actionId, app_connector_id, [inputName], action.inputs);
                if (resp.code === 200 && resp.data[inputName]) {
                    value.options = resp.data[inputName].options;
                    value.type = 'select';
                    if (resp.data[inputName].option_fetch_error) {
                        value.option_fetch_error = true;
                    }
                }
            }
        }

        if (value.type === "number") {
            if (value.value.trim() !== '' && !isNaN(value.value)) {
                value.value = parseInt(value.value, 10)
            } else {
                //value.value = "";
            }
        }

        if (value.type === "decimal") {
            if (value.value.trim() !== '' && !isNaN(value.value)) {
                value.value = parseFloat(value.value)
            } else {
                value.value = "";
            }
        }

        action.fields[sysActionFieldName].value[inputName] = value;

        const field = initialActionsData[action.id]?.fields[sysActionFieldName];
        let oldValue = !field ? undefined : field.value[inputName]?.value;
        let newValue = value.value !== undefined ? value.value : value;
        CheckIfFlowUpdated(inputName, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
        setTimeout(() => {
            copyFields[inputName] = value;
            setSysActionFields(copyFields);
            // setSaveAvailable(true);
            setFieldLoading(false)
        }, 300)
    }


    const setSysRequiredFields = async (required_fields) => {

        for (const item of required_fields) {
            if (!action.fields[sysActionFieldName]?.value[item.path]) {
                if (item.value.options && item.value.options.length === 0) {
                    const conn = appConnectors.find(c => c.default_value === aafcApplicationId);
                    if (conn && selectedConnectors[conn.name]) {
                        const app_connector_id = selectedConnectors[conn.name].value;
                        const resp = await ActionService.getSysFieldOptions(action.actionId, app_connector_id, [item.path], action.inputs);
                        if (resp.code === 200 && resp.data[item.path]) {
                            item.value.options = resp.data[item.path].options;
                            item.value.type = 'select';
                            if (resp.data[item.path].option_fetch_error) {
                                item.value.option_fetch_error = true;
                            }
                        }
                    }
                }
                action.fields[sysActionFieldName].value[item.path] = item.value;
            }

            //copyFields[item.path] = item.value;
        }

        setTimeout(() => {

            //copyFields[inputName] = value;
            // setSysActionFields(copyFields);
            setSysActionFields(action.fields[sysActionFieldName].value);
            setSaveAvailable(true);

            //const field = initialActionsData[action.id]?.fields[sysActionFieldName];
            // let oldValue = !field ? undefined : field.value[inputName];
            //CheckIfFlowUpdated(inputName, action, oldValue, action.fields[sysActionFieldName].value[inputName], setSaveAvailable, setChangeFields, changedFieldsState);

        }, 300)
    }

    // set action field
    const setSysSelectField = (inputName, value) => {
        let copyFields = { ...sysActionFields };
        copyFields[inputName].value = value;
        setSysActionFields(copyFields);
        //let copySelectedCustomSelectableField = { ...selectedCustomSelectableField };
        // copySelectedCustomSelectableField[inputName] = value;
        // setSelectedCustomSelectableField(copySelectedCustomSelectableField);
        action.fields[sysActionFieldName].value[inputName].value = value;
        const field = initialActionsData[action.id]?.fields[sysActionFieldName];
        let oldValue = !field ? undefined : field.value[inputName]?.value;
        let newValue = value.value !== undefined ? value.value : value;
        CheckIfFlowUpdated(inputName, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
        // setSaveAvailable(true);
    }

    const removeCustomField = (inputName) => {
        let copyFields = { ...sysActionFields };
        delete copyFields[inputName]
        setSysActionFields(copyFields);
        delete action.fields[sysActionFieldName].value[inputName]
        const field = initialActionsData[action.id]?.fields[sysActionFieldName];
        let oldValue = !field ? undefined : field.value[inputName];
        CheckIfFlowUpdated(inputName, action, oldValue, action.fields[sysActionFieldName].value[inputName], setSaveAvailable, setChangeFields, changedFieldsState);
    }

    const removeCustomSelectField = (inputName) => {
        let copyFields = { ...sysActionFields };
        delete copyFields[inputName]
        setSysActionFields(copyFields);
        // let copySelectedCustomSelectableField = { ...selectedCustomSelectableField };
        // delete copySelectedCustomSelectableField[inputName];
        // setSelectedCustomSelectableField(copySelectedCustomSelectableField);
        delete action.fields[sysActionFieldName].value[inputName];
        const field = initialActionsData[action.id]?.fields[sysActionFieldName];
        let oldValue = !field ? undefined : field.value[inputName];
        CheckIfFlowUpdated(inputName, action, oldValue, action.fields[sysActionFieldName].value[inputName], setSaveAvailable, setChangeFields, changedFieldsState);
    }

    // select input field option
    const changeInputOption = (inputName, value) => {
        // let _selectedInputOption = { ...selectedInputOption };
        // // _selectedInputOption[inputName] = value;
        // setSelectedInputOption(_selectedInputOption);
        action.fields[inputName].value = value;
        const field = initialActionsData[action.id]?.fields[inputName];
        let oldValue = !field ? undefined : field.value;
        let newValue = value.value !== undefined ? value.value : value;
        CheckIfFlowUpdated(inputName, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState);
        // action.fields[inputName].value = value;
        // setSaveAvailable(true);
    }

    const checkAndOpenAppCredentialModal = (application_id) => {
        const app = applications.find(x => x.id === application_id)
        if (!app || !app.connector_fields) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t('FLOW-MESSAGES.LIBRARY.GENERAL.UNKNOWN-ERROR'),
                severity: 'error'
            }));
            return;
        }
        setOpenAppCredential(true);
    }

    const handleExpireToken = (name, sc) => {
        setAlert(alert => ({
            ...alert,
            show: true,
            message: t('MESSAGES.AUTOMS.OAUTH-REFRESH-TOKEN-EXPIRED'),
            severity: 'error'
        }));
        let copyConnectors;
        if (sc) {
            copyConnectors = { ...sc };
        } else {
            copyConnectors = { ...selectedConnectors };
        }
        copyConnectors[name].error = true;
        setSelectedConnectors(copyConnectors);
        setCredentialQuestion(true);
    }

    const getElementByType = (path, obj) => {
        if ((obj.type === 'select' || obj.type === 'multi_select') &&
            (obj.options && obj.options.length || obj.option_fetch_error)) {
            return <CustomTab action={action.fields[sysActionFieldName].value}
                displayName={obj.name}
                inputName={path}
                options={obj.option_fetch_error ? [] : obj.options}
                type={obj.type} variableRender={variableRender}
                variables={variables}
                setOpenVariable={setOpenVariable}
                setField={setSysField}
                optionFetchError={obj.option_fetch_error}
                onChange={(v) => setSysSelectField(path, v)}
                multiple={obj.type === 'multi_select'}
            />
        } else if (obj.type === 'date' || obj.type === 'datetime' || obj.type === 'time') {
            return <CustomDateTab action={action.fields[sysActionFieldName].value}
                displayName={obj.name}
                inputName={path}
                type={obj.type} variableRender={variableRender}
                variables={variables}
                setOpenVariable={setOpenVariable}
                setField={setSysField}
                isRequired={true}
                onChange={(v) => setSysSelectField(path, v)}
            />
        } else if (obj.type === 'boolean') {
            return <BoolSelect
                inputName={path}
                variableRender={variableRender}
                variables={variables}
                action={action.fields[sysActionFieldName].value}
                displayName={obj?.name}
                setOpenVariable={setOpenVariable}
                type={obj?.type}
                isRequired={true}
                setField={setSysField}
                onChange={setSysSelectField}
            />
        } else {
            return <TextInput
                inputName={path}
                action={action.fields[sysActionFieldName].value}
                setField={setSysField}
                variableRender={variableRender}
                variables={variables}
                include={[obj.type]}
                multiline={obj?.type === "object"}
                setOpenVariable={setOpenVariable}
                isRequired={true}
                fieldType={obj.type}
                displayName={obj.name}
                hideRequired={true}
            />
        }
    }

    const connectRequiredField = (inputs) => {
        let isChanged = false;
        for (const key in inputs) {
            if (action.fields[key]) {
                if (typeof inputs[key] === "string") {
                    action.fields[key].value = inputs[key];
                } else {
                    const keys = Object.keys(inputs[key]);
                    const firstKey = keys[0];
                    action.fields[key].value = inputs[key][firstKey];
                }

                isChanged = true;
            }
        }

        if (isChanged) {
            setInputRefreshGlobal(new Date());
        }
    }

    return (

        <>
            {credentialQuestion &&
                <OauthQuestion setOpenDelete={setCredentialQuestion}
                    message={t(label + "WOULD-YOU-LIKE-TO-BE-REDIRECT-OAUTH-LOGIN-PAGE")}
                    deleteFunc={openCredentialModal} />}
            {appConnectors && appConnectors.length > 0 && (
                appConnectors.map((c, index) => (
                    <div className="field-form-section" key={index}>
                        <div className="dialog-text">
                            {t(label + "CREDENTIAL")}
                            {/* <span className='required-span'>(Required)</span> */}
                            <span className='required-span'>({t('CONTENT.FLOW.REQUIRED')})</span>

                            <AddIcon className="credential-add-icon" onClick={() => checkAndOpenAppCredentialModal(c.default_value)} /></div>
                        <small className="credential-helper">{t(label + "CREDENTIAL-HELP")}</small>
                        <FormControl
                            variant="outlined"
                            style={{ width: "100%" }}
                        >
                            <Autocomplete
                                style={{
                                    backgroundColor: "#fff",
                                    height: "40px",
                                    fontSize: "12px"
                                }}
                                onChange={(event, value, reason) => {
                                    return handleChangeCredential(value ? value : "", c.name)
                                }}
                                value={action.fields[c.name]?.name}
                                id="demo-simple-select-outlined"
                                size="small"
                                options={applicationCredentials.length > 0 ? applicationCredentials : []}
                                getOptionLabel={(item) => {
                                    if (item.name) {
                                        return item.name
                                    }
                                    return item
                                }}
                                renderInput={(params) => <TextField {...params} variant="outlined" />}
                            />
                        </FormControl>
                        {openAppCredential &&
                            <AppCredentialModal appCredentialId={selectedConnectors[c.name]?.error ? selectedConnectors[c.name].value : ""} selectedApp={applications.find(x => x.id === c.default_value)}
                                afterSave={afterSave} cancel={cancel} data={applicationCredentials} />}

                        {!loading && aafcApplicationId === c.default_value && selectedConnectors[c.name] && !selectedConnectors[c.name].error &&
                            <ConnectorField automDetail={automDetail} showFieldPreview={!!selectedConnectors[c.name]}
                                triggerConfig={triggerConfig}
                                setTriggerConf={setTriggerConfig} automVersionId={automVersionId}
                                triggerExpanded={false} debugOpen={debuggingStart} action={action}
                                debugExpand={debuggingExpand} onFlowPage={true} automId={automId}
                                selectedCredential={selectedConnectors[c.name]}
                                disabledFields={sysActionFields}
                                setDisabledFields={setSysFieldAdd}
                                fieldLoading={fieldLoading}
                                setSysRequiredFields={setSysRequiredFields}
                                rightLocation={true} //sampleResponses={sampleResponses}
                                variables={variables} setOpenVariable={setOpenVariable}
                                disableInputs={customInputs}
                                handleExpireToken={() => handleExpireToken(c.name)}
                                resizeClassName={!fromFlow ? "dialog-data-table" : ""}
                                connectRequiredField={connectRequiredField}
                                changedCredential={changedConnector}
                            />
                        }
                    </div>
                ))
            )}

            {/* {selectedConnectors[connectorName] &&
                <ConnectorField showFieldPreview={!!selectedConnectors[connectorName]} triggerConfig={triggerConfig}
                    setTriggerConf={setTriggerConfig} automVersionId={automVersionId}
                    triggerExpanded={false} debugOpen={debuggingStart} action={action}
                    debugExpand={debuggingExpand} onFlowPage={true} automId={automId}
                    selectedCredential={selectedConnectors[connectorName]} disabledFields={sysActionFields}
                    setDisabledFields={setSysField} rightLocation={true} customItems={customItems} />
            } */}
            {
                loading ? <CircularProgress className='loading-circular-process' /> :
                    appConnectors.length && selectedConnectors[appConnectors.find(x => x.default_value === aafcApplicationId)?.name] && itemId === action.item_id && (
                        <>
                            {
                                customInputs.length || customOutputs.length ? (
                                    <div>
                                        <h4>{t(label + "DEFAULT-FIELDS")}</h4>
                                        <div className="custom-form-fields">
                                            {
                                                customInputs?.map((inputVariable, index) =>

                                                    <div className="conf-field-container" key={index}>
                                                        <FieldLabel display_name={inputVariable?.display_name} name={inputVariable?.name} is_required={inputVariable.is_required} />
                                                        {/* <div className='conf-field-name'>
                                                            {inputVariable?.display_name ? inputVariable?.display_name : inputVariable?.name}
                                                            {
                                                                inputVariable.is_required &&
                                                                <span className='required-span'>(Required)</span>
                                                            }
                                                        </div> */}
                                                        {
                                                            fieldOptions[inputVariable.name] &&
                                                                (fieldOptions[inputVariable.name].options && fieldOptions[inputVariable.name].options.length ||
                                                                    fieldOptions[inputVariable.name].option_fetch_error) ? (

                                                                <CustomTab action={action} displayName={inputVariable.name}
                                                                    isRequired={inputVariable.is_required}
                                                                    inputName={inputVariable?.name}
                                                                    options={fieldOptions[inputVariable.name].option_fetch_error ? [] : fieldOptions[inputVariable.name].options}
                                                                    type={inputVariable.type}
                                                                    variableRender={variableRender}
                                                                    variables={variables}
                                                                    setOpenVariable={setOpenVariable}
                                                                    optionFetchError={fieldOptions[inputVariable.name].option_fetch_error}
                                                                    disabled={!!fieldOptions[inputVariable.name].disabled}
                                                                    onChange={(v) => changeInputOption(inputVariable.name, v)}
                                                                />
                                                                // <FormControl
                                                                //     variant="outlined"
                                                                //     style={{ width: "100%" }}
                                                                // >
                                                                //     <Select
                                                                //         labelId="demo-simple-select-outlined-label"
                                                                //         style={{
                                                                //             backgroundColor: "#fff",
                                                                //             height: "40px",
                                                                //             fontSize: "12px",
                                                                //         }}
                                                                //         value={selectedInputOption[inputVariable.name]}
                                                                //         id="demo-simple-select-outlined"
                                                                //         onChange={(e) => changeInputOption(inputVariable.name, e.target.value)}
                                                                //     >
                                                                //         {
                                                                //             fieldOptions[inputVariable.name].options.map((cred) => (
                                                                //                 <MenuItem
                                                                //                     style={{ fontSize: 12 }}
                                                                //                     value={cred.value}
                                                                //                 >
                                                                //                     {cred.display_name}
                                                                //                 </MenuItem>
                                                                //             ))}
                                                                //     </Select>
                                                                // </FormControl>

                                                            ) :
                                                                (
                                                                    inputVariable.type === 'boolean' ?
                                                                        <BoolSelect
                                                                            inputName={inputVariable?.name}
                                                                            variableRender={variableRender}
                                                                            variables={variables}
                                                                            action={action}
                                                                            displayName={inputVariable?.name}
                                                                            setOpenVariable={setOpenVariable}
                                                                            type={inputVariable?.type}
                                                                            isRequired={inputVariable.is_required}
                                                                            onChange={changeInputOption}
                                                                        />
                                                                        :
                                                                        <TextInput inputName={inputVariable?.name}
                                                                            variableRender={variableRender}
                                                                            variables={variables}
                                                                            action={action}
                                                                            include={[inputVariable.type]}
                                                                            multiline={inputVariable?.type === "object"}
                                                                            setOpenVariable={setOpenVariable}
                                                                            isRequired={inputVariable.is_required}
                                                                            fieldType={inputVariable?.type}
                                                                            displayName={inputVariable?.name}
                                                                            hideRequired={true}
                                                                            disabled={!!(fieldOptions[inputVariable.name] && fieldOptions[inputVariable.name].disabled)}
                                                                        />
                                                                )
                                                        }
                                                        {inputVariable?.description && inputVariable?.description !== '<p><br></p>' &&
                                                            <small><em>{HTMLReactParser(inputVariable?.description)}</em></small>
                                                        }
                                                    </div>
                                                )
                                            }

                                            {customOutputs?.map((outputVariable, index) =>
                                                <div className="conf-field-container" key={index}>
                                                    <FieldLabel display_name={outputVariable?.display_name} name={outputVariable?.name} is_required={outputVariable.is_required} />

                                                    <VariablePicker action={action} inputName={outputVariable?.name}
                                                        variables={variables}
                                                        disabled={action.fields[outputVariable?.name] && action.fields[outputVariable?.name].value}
                                                        setOpenVariable={setOpenVariable}
                                                        styles={{ backgroundColor: "white" }}
                                                        filter={outputVariable?.type}
                                                        isRequired={outputVariable.is_required}
                                                        isOutput={true}
                                                        hideRequired={true}
                                                    />

                                                    <small className='conf-field-desc'><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: outputVariable?.type })}</em></small>
                                                    {outputVariable?.description !== '<p><br></p>' && HTMLReactParser(outputVariable?.description) &&
                                                        <small><em>{HTMLReactParser(outputVariable?.description)}</em></small>
                                                    }
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div style={{
                                        padding: "50px 10px",
                                        color: "#e39b9b",
                                        textAlign: "center"
                                    }}>{t('CONTENT.CONFIGURATION-FORM.NO-CONFIGURABLE-VARIABLE-FOUND')}</div>
                                )
                            }
                            {
                                Object.entries(sysActionFields).length > 0 &&
                                (
                                    <div>
                                        <h4>{t(label + "INPUT-FIELDS")}</h4>
                                        <div className="custom-form-fields">
                                            {
                                                Object.entries(sysActionFields).map(([path, obj], index) => (
                                                    <div className="form-element" key={index}>
                                                        <div className='input-field-title'>
                                                            <div className='display-container'>
                                                                <span>{obj.displayName ? obj.displayName : obj.name}</span>
                                                                <MyToolTip description={path} />
                                                                <span className='required-span'>({t('CONTENT.FLOW.REQUIRED')})</span>
                                                            </div>
                                                            <img className='field-close-icon' src={deleteIcon}
                                                                onClick={() => obj.type === 'select' ? removeCustomSelectField(path) : removeCustomField(path)} />
                                                            {/* <Close className='field-close-icon' onClick={() => obj.type === 'select' ? removeCustomSelectField(path) : removeCustomField(path)} /> */}
                                                            {/* <Button size="small" data-test="cancelautom-button"
                                                                onClick={() => obj.type === 'select' ? removeCustomSelectField(path) : removeCustomField(path)}>
                                                                
                                                            </Button> */}

                                                        </div>
                                                        {
                                                            getElementByType(path, obj)
                                                        }

                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        </>
                    )
            }


        </>
    )
}

export default CustomAction
